






import Vue from 'vue'

export default Vue.extend({
  name: 'LinkedInInfo',
  data() {
    return {
      route: 'https://www.linkedin.com/in/elle-ryba/',
    }
  },
  methods: {},
})
